// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LhNZ79BtdtURj0xr0gGYO","groupsList":"_1T6ubst_PugNaMBcjGkcF1"};